"use client";
import { getBlogPostList, getRelatedBlogs } from "@/api/blog";
import { useParams, usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import ArticleCard from "../article-card";

type RelatedBlogsResponse = {
  count: number;
  related_posts: any[];
};

const RelatedArticles = ({ title }: {
  title?: "مقالات پیشنهادی" | "مقالات مرتبط"
}) => {
  const [sidebarBlogsList, setSidebarBlogsList] = useState<any[]>([]);
  const pathname = usePathname();
  const sidebarTitle =
    title ?? (pathname.includes("/content") ? "مقالات مرتبط" : "مقالات پیشنهادی");

  const { id } = useParams<{ id: string }>() || { id: "" };

  useEffect(() => {
    const load = async () => {
      let res;

      if (sidebarTitle === "مقالات پیشنهادی") {
        res = await getBlogPostList({ suggested: true });
        setSidebarBlogsList(res?.results ?? []);
      } else if (sidebarTitle === "مقالات مرتبط" && id) {
        const res: RelatedBlogsResponse = await getRelatedBlogs(+id);
        setSidebarBlogsList(res.related_posts ?? []);
      }

    };

    load();
  }, [sidebarTitle, id]);

  if (!sidebarBlogsList?.length) return null;

  return (
    <ul className="max-w-3xl flex flex-col gap-6">
      <h3 className="font-bold text-lg">{sidebarTitle}</h3>
      {sidebarBlogsList.map((blog: any) => (
        <ArticleCard
          mini
          key={blog?.content_id}
          props={blog}
        />
      ))}
    </ul>
  );
};

export default RelatedArticles;